import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { tooltipFormatterPie } from 'helpers/echart-utils';
import { useAppContext } from 'providers/AppProvider';

interface ScoreCardQuestionWeightChartProps {
  data: { value: number; name: string }[];
}

const ScoreCardQuestionWeightChart: React.FC<
  ScoreCardQuestionWeightChartProps
> = ({ data }) => {
  // eslint-disable-next-line
  const { config: { isDark }, getThemeColor } = useAppContext();
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let chartInstance: echarts.ECharts | null = null;

    // Inicializar el gráfico
    const renderChart = () => {
      if (chartRef.current) {
        chartInstance = echarts.init(chartRef.current);

        const chartOption: echarts.EChartsOption = {
          tooltip: {
            trigger: 'item',
            // eslint-disable-next-line
            formatter: (params: any) => tooltipFormatterPie(params, 'MMM DD, YYYY'),
            // eslint-disable-next-line
            backgroundColor: !isDark ? 'rgba(240, 240, 240, 0.9)' : 'rgba(49, 55, 74, 0.9)',
            textStyle: {
              color: !isDark ? '#202020' : '#ccc',
              fontFamily: 'Nunito Sans',
              fontSize: 14
            },
            borderWidth: 1,
            // eslint-disable-next-line
            borderColor: !isDark ? 'rgba(49, 55, 74, 0.4)' : 'rgba(140, 140, 180, 0.8)',
            padding: 10
          },
          series: [
            {
              name: 'Question weight',
              type: 'pie',
              radius: [30, 40],
              center: ['50%', '50%'],
              itemStyle: {
                borderRadius: 5,
                // eslint-disable-next-line
                color: !isDark ? getThemeColor('primary') : getThemeColor('primary')
              },
              label: {
                show: true,
                // eslint-disable-next-line
                color: !isDark ? 'rgba(110, 110, 130, 0.9)' : 'rgba(130, 130, 140, 0.9)',
                fontFamily: 'Nunito Sans',
                fontSize: 12,
                formatter: '{b}'
              },
              data
            }
          ]
        };

        chartInstance.setOption(chartOption);

        // Redimensionar el gráfico cuando cambia el tamaño de la ventana
        const handleResize = () => {
          chartInstance?.resize();
        };

        window.addEventListener('resize', handleResize);

        // Limpiar los listeners y la instancia del gráfico al desmontar
        return () => {
          window.removeEventListener('resize', handleResize);
          chartInstance?.dispose();
        };
      }
    };

    renderChart();
  }, [data, isDark]);

  return <div ref={chartRef} style={{ height: '120px', width: '100%' }} />;
};

export default ScoreCardQuestionWeightChart;
